import { SkeletonContainer, StyledSkeleton } from "./styled-components";

export const LoadingSubscriptions = () => {
  return (
    <SkeletonContainer>
      <StyledSkeleton $width="100%" $maxWidth="100%" />
      <StyledSkeleton $width="200px" $maxWidth="20%" />
    </SkeletonContainer>
  );
};
